var map = {
	"./0.jpg": "5cRF",
	"./1.jpg": "3+nz",
	"./2-0.jpg": "VxzT",
	"./2.jpg": "HRBD",
	"./2189b4091efde86a.jpg": "eNXv",
	"./3.jpg": "kJGS",
	"./4.jpg": "LTDO",
	"./5.jpg": "bZ8B",
	"./fresh-news.png": "fDDk",
	"./icons/fruit-active.png": "wDpV",
	"./icons/fruit.png": "J/V4",
	"./icons/ice-cream-active.png": "JbXE",
	"./icons/ice-cream.png": "H6p8",
	"./icons/juice-active.png": "Py2b",
	"./icons/juice.png": "fP7t",
	"./icons/meat-active.png": "FCwV",
	"./icons/meat.png": "hrW8",
	"./icons/seafood-active.png": "kU6O",
	"./icons/seafood.png": "tscv",
	"./icons/vegetables-active.png": "lz+9",
	"./icons/vegetables.png": "C68B",
	"./logo.png": "vB+Z",
	"./logo1.png": "Fock",
	"./logo2.png": "nDLT",
	"./logo3.png": "e1qu",
	"./main-view-bg.png": "Nbql"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48Db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view ^\.\/.*$
// module id = 48Db
// module chunks = 1